import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'odq-dated-text-input',
    templateUrl: './dated-text-input.component.html',
    styleUrls: ['./dated-text-input.component.scss'],
    standalone: false
})
export class DatedTextInputComponent implements OnInit {

  @Input() label: string;
  @Input() parentForm: UntypedFormGroup;

  constructor() { }

  ngOnInit() {
  }

}
